<div class="assets">
    <!-- Left rail: the customer's pools and spas -->
    <div class="assets-structures">
        <button class="btn btn-outline-primary mb-2 w-100" (click)="toggleStructureForm()">
            <i class="bi" [ngClass]="showStructureForm ? 'bi-x-lg' : 'bi-plus-lg'"></i>
            {{ showStructureForm ? 'Cancel' : 'Add Structure' }}
        </button>

        <div *ngIf="showStructureForm" class="card p-3 mb-3 border">
            <div class="mb-2">
                <label for="structureType" class="form-label">Structure Type</label>
                <select id="structureType" class="form-select" [(ngModel)]="addStructureTypeId">
                    <option [value]="0" disabled>Select Type</option>
                    <option *ngFor="let type of structureTypes" [value]="type.id">
                        {{ type.name }}
                    </option>
                </select>
            </div>

            <div class="mb-2">
                <label for="description" class="form-label">Description</label>
                <input id="description"
                       type="text"
                       class="form-control"
                       required
                       [(ngModel)]="structureDescription"
                       placeholder="Enter description" />
            </div>

            <div class="mb-2">
                <label class="form-label">Pool Shape</label>
                <select class="form-select"
                        [(ngModel)]="poolShape"
                        (ngModelChange)="calculateGallons()">
                    <option value="rectangle">Rectangle</option>
                    <option value="round">Round</option>
                    <option value="oval">Oval</option>
                </select>
            </div>

            <div class="form-check form-switch mb-3">
                <input class="form-check-input"
                       type="checkbox"
                       id="calcToggle"
                       [(ngModel)]="isCalculating">

                <label class="form-check-label" for="calcToggle">
                    Calculate volume
                </label>
            </div>

            <!-- Enter gallons directly -->
            <div *ngIf="!isCalculating" class="mb-3">
                <label for="poolGallons" class="form-label">Pool Volume (Gallons)</label>
                <input id="poolGallons"
                       type="number"
                       class="form-control"
                       [(ngModel)]="poolGallons"
                       placeholder="Enter total gallons">
            </div>

            <!-- Calculate from dimensions -->
            <div *ngIf="isCalculating" class="mb-3">
                <div *ngIf="poolShape === 'rectangle' || poolShape === 'oval'" class="row g-2">
                    <div class="col-6 mb-2">
                        <label class="form-label">Length (ft)</label>
                        <input type="number" class="form-control" [(ngModel)]="poolLength" (ngModelChange)="calculateGallons()">
                    </div>

                    <div class="col-6 mb-2">
                        <label class="form-label">Width (ft)</label>
                        <input type="number" class="form-control" [(ngModel)]="poolWidth" (ngModelChange)="calculateGallons()">
                    </div>
                </div>

                <div *ngIf="poolShape === 'round'" class="mb-2">
                    <label class="form-label">Diameter (ft)</label>
                    <input type="number" class="form-control" [(ngModel)]="poolDiameter" (ngModelChange)="calculateGallons()">
                </div>

                <div class="row g-2">
                    <div class="col-6 mb-2">
                        <label class="form-label">Shallow Depth (ft)</label>
                        <input type="number" class="form-control" [(ngModel)]="poolShallowDepth" (ngModelChange)="calculateGallons()">
                    </div>

                    <div class="col-6 mb-2">
                        <label class="form-label">Deep Depth (ft)</label>
                        <input type="number" class="form-control" [(ngModel)]="poolDeepDepth" (ngModelChange)="calculateGallons()">
                    </div>
                </div>

                <div class="mb-2">
                    <label class="form-label">Calculated Gallons</label>
                    <input type="number" class="form-control" [value]="calculatedGallons" readonly>
                </div>
            </div>

            <button class="btn btn-success w-100" (click)="addStructure()" [disabled]="!canSubmitStructure()">Submit</button>
        </div>

        <div *ngIf="isLoading" class="text-muted small px-1">Loading...</div>

        <div *ngIf="!isLoading && structures.length === 0 && !showStructureForm" class="text-muted small px-1 mb-3">
            No pools or spas set up for this customer yet.
        </div>

        <ul class="list-group mb-3">
            <li *ngFor="let s of structures"
                class="list-group-item list-group-item-action d-flex flex-column structure-item"
                [class.active-structure]="selectedStructure?.id === s.id">

                <div class="d-flex justify-content-between align-items-center w-100 gap-2">
                    <div (click)="selectStructure(s)" class="flex-grow-1 structure-label">
                        <span class="fw-bold me-1">{{ getStructureTypeName(s.structureTypeId) }}:</span>
                        <span class="text-muted">{{ s.description }}</span>
                        <span class="text-muted"> - Volume: {{ s.volume }} gals</span>
                    </div>

                    <div class="btn-group flex-shrink-0">
                        <button type="button"
                                class="btn btn-sm btn-outline-primary"
                                title="Edit"
                                (click)="editStructure(s)">
                            <i class="bi bi-pencil"></i>
                        </button>

                        <button type="button"
                                class="btn btn-sm btn-outline-danger"
                                title="Delete"
                                (click)="deleteStructure(s)">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                </div>

                <!-- Inline edit -->
                <div *ngIf="editingStructure?.id === s.id" class="mt-2 w-100">
                    <div class="mb-2">
                        <label class="form-label">Structure Type</label>
                        <select class="form-select form-select-sm" [(ngModel)]="editingStructure.structureTypeId">
                            <option *ngFor="let type of structureTypes" [ngValue]="type.id">{{ type.name }}</option>
                        </select>
                    </div>

                    <div class="mb-2">
                        <label class="form-label">Description</label>
                        <input type="text" [(ngModel)]="editingStructure.description" class="form-control form-control-sm" placeholder="Description" />
                    </div>

                    <div class="mb-2">
                        <label class="form-label">Pool Volume (Gallons)</label>
                        <input type="number" [(ngModel)]="editingStructure.volume" class="form-control form-control-sm" placeholder="Volume" />
                    </div>

                    <div class="d-flex gap-2">
                        <button class="btn btn-sm btn-success flex-grow-1" (click)="saveStructureEdit()">Save</button>
                        <button class="btn btn-sm btn-secondary flex-grow-1" (click)="cancelStructureEdit()">Cancel</button>
                    </div>
                </div>
            </li>

            <!-- Always offered: it collects anything not attached to a live pool - records made before
                 this customer had assets, and records left behind by a deleted one. -->
            <li class="list-group-item list-group-item-action structure-item"
                [class.active-structure]="isUnassigned"
                (click)="selectUnassigned()">
                <span class="fw-bold me-1">Unassigned</span>
                <span class="text-muted d-block small">Recorded before this customer had assets</span>
            </li>
        </ul>
    </div>

    <!-- Right: the selected asset -->
    <div class="assets-detail" *ngIf="selectedStructure">
        <h5 class="mb-2">
            {{ selectedStructureTitle }}
            <small class="text-muted" *ngIf="!isUnassigned">{{ selectedStructure.description }}</small>
        </h5>

        <ul class="nav nav-tabs mb-3">
            <li class="nav-item" *ngIf="canShowOrenda()">
                <a class="nav-link" [class.active]="selectedTab === 'orenda'" (click)="onTabClicked('orenda')">Orenda Calculator</a>
            </li>
            <li class="nav-item" *ngIf="canShowReadingsAndDosages()">
                <a class="nav-link" [class.active]="selectedTab === 'readings'" (click)="onTabClicked('readings')">Readings and Dosages</a>
            </li>
            <li class="nav-item" *ngIf="canShowEquipment()">
                <a class="nav-link" [class.active]="selectedTab === 'equipment'" (click)="onTabClicked('equipment')">Auto Cover / Equipment</a>
            </li>
        </ul>

        <div *ngIf="!selectedTab" class="text-muted">
            Nothing is enabled for this asset. Turn on Orenda or Readings &amp; Dosages in Settings to record against it.
        </div>

        <orenda *ngIf="selectedTab === 'orenda'"
                [jobId]="jobId"
                [jobDocumentKey]="documentKey"
                [customerId]="customerId"
                [structure]="selectedStructure"></orenda>

        <assets-readings-and-dosages *ngIf="selectedTab === 'readings'"
                                     [customerId]="customerId"
                                     [structureId]="selectedStructure.id"></assets-readings-and-dosages>

        <div *ngIf="selectedTab === 'equipment'">
            <div *ngIf="isLoadingEquipment" class="text-muted">Loading equipment...</div>

            <equipment-tracking *ngIf="!isLoadingEquipment"
                                [jobId]="jobId"
                                [jobDocumentKey]="documentKey"
                                [structureId]="selectedStructure.id"
                                [showSaveButton]="true"
                                [equipmentTrackingModels]="equipmentTrackingModels"></equipment-tracking>
        </div>
    </div>
</div>

<slick-confirm-dialog #deleteStructureConfirmRef [width]="420" okButtonText="Delete">
    <div class="text-danger">Are you sure you want to delete this structure?</div>
    <div class="mt-2">
        Readings, dosages and equipment already recorded on it are kept, and will move to Unassigned.
    </div>
</slick-confirm-dialog>
